import { FC, useEffect } from "react";
import { LinkProps, useNavigate } from "react-router-dom";

export const Redirect: FC<{ href: LinkProps["to"] }> = ({ href }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(href);
  });

  return null;
};
